import ReactMarkdown, { Components } from 'react-markdown';

/**
 * Converts double newlines (\n\n) to single newlines (\n)
 */
const convertDoubleNewlinesToSingle = (text: string): string => {
  return text.replace(/\n\n/g, '\n');
};

const defaultComponents: Components = {
  ul: ({ node, ordered, ...props }) => (
    <ul style={{ paddingLeft: '1em', marginTop: '0.25em', marginBottom: '0.25em' }} {...props} />
  ),
  ol: ({ node, ordered, ...props }) => (
    <ol style={{ paddingLeft: '1em', marginTop: '0.25em', marginBottom: '0.25em' }} {...props} />
  ),
  li: ({ node, ordered, ...props }) => <li style={{ marginBottom: '0.25em' }} {...props} />,
  p: ({ node, ...props }) => (
    <p
      style={{
        marginBottom: '0.5em',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
      }}
      {...props}
    />
  )
};

const Markdown = ({ children, components = {} }: { children: string; components?: Components }) => {
  const processedChildren = children.replace(/([^\n])\n(?=[^\n])/g, '$1  \n'); // replace \n with 2 spaces and a new line
  return (
    <div
      style={{
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
      }}
    >
      <ReactMarkdown components={{ ...defaultComponents, ...components }}>
        {processedChildren}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
export { convertDoubleNewlinesToSingle };
